import React from 'react';
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import {StyledButton, StyledCard, StyledTag} from "./ApprovedRequests.styled";
import {Button, Col, Flex, Tag} from "antd";
import style from "./ApprovedRequests.module.scss";
import {ApprovedRequestCardProps} from "../../models";
import {RiShieldCheckFill} from "react-icons/ri";
import { IoCloseCircleOutline  } from "react-icons/io5";
import { MdGroups } from "react-icons/md";


const ApprovedRequestCard = ({detail}: ApprovedRequestCardProps) => {
    return (
        <StyledCard>
            <Flex align={"center"} justify={"space-between"}>
                <Col xs={7} sm={7} md={6} lg={8} xl={8}>
                    <img className={style.customImg} src={require("assets/Logo/ad2.png")} width={23} height={15}/>
                </Col>
                <Col xs={16} sm={16} md={17} lg={8} xl={8}>
                    <Flex vertical justify={"space-between"}>
                        <Flex justify={"start"}>
                            { detail?.isApproved ?
                                <span className={style.requestDetailApproved}>
                            <RiShieldCheckFill/> تایید شده</span>:
                                <span className={style.requestDetailRejected}>
                            <IoCloseCircleOutline   /> رد شده</span>}

                        </Flex>
                        <Flex justify={"start"}>
                            <span className={style.requestDetailTitle}>{detail?.title}</span>
                        </Flex>

                        <Flex justify={"space-between"} align={"center"}>
                            <Flex vertical gap={"small"}>
                                <span
                                    className={style.requestDetailText}>از تاریخ <StyledTag>{detail?.fromDate}</StyledTag></span>
                                <span
                                    className={style.requestDetailText}>تا تاریخ <StyledTag>{detail?.toDate}</StyledTag></span>
                            </Flex>
                            <Flex vertical gap={"small"} justify={"center"} align={"center"}>
                                <StyledButton icon={<MdGroups/>} size={"small"}>افراد</StyledButton>
                                <span className={style.requestDetailText}>{detail?.requestDate}</span>
                            </Flex>
                        </Flex>
                    </Flex>
                </Col>
            </Flex>
        </StyledCard>
    );
};

export default connect(null, {})(
    withRouter(ApprovedRequestCard)
);
